const preloader = document.getElementById('preloader');
if(preloader){
  const hidePreloader = () => {
    const duration = (preloader.dataset.duration || 2) * 1000;
    
    setTimeout(() => {
      preloader.style.transition = 'opacity 0.3s ease';
      preloader.style.opacity = '0';
      
      setTimeout(() => {
        preloader.style.display = 'none';
      }, 300); // Wait for transition to complete
      
    }, duration);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hidePreloader, { once: true });
  } else {
    hidePreloader();
  }
} else {
}
